import checkoutImg from "@/assets/client-design/feature-checkout-split.jpg";
import shareImg from "@/assets/client-design/feature-share-link.jpg";
import dashboardImg from "@/assets/client-design/feature-merchant-dashboard.jpg";

const steps = [
  {
    n: "01",
    title: "Customer splits at checkout",
    body: "Shoppers see a Split with Friends option right next to the normal purchase flow. One tap, no credit checks, no debt.",
    image: checkoutImg,
    alt: "Shopify Split Payment App showing the Split with Friends button on a checkout page",
  },
  {
    n: "02",
    title: "Invite friends by email or WhatsApp",
    body: "The organizer can send secure split-payment links by email or WhatsApp, and each friend pays only their portion.",
    image: shareImg,
    alt: "Group gifting payment link with secure participant checkout",
  },
  {
    n: "03",
    title: "Merchant gets paid in full",
    body: "The order completes once everyone has contributed. Merchants track the split from a single dashboard.",
    image: dashboardImg,
    alt: "Splitkart merchant dashboard showing split-payment status and order tracking",
  },
];

export function HowItWorksVisual() {
  return (
    <section className="section bg-surface">
      <div className="container-tight">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">How it works</span>
          <h2 className="mt-3 text-2xl font-bold md:text-4xl">
            From cart to <span className="text-primary">shared checkout</span> in three simple steps.
          </h2>
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-3">
          {steps.map((step) => (
            <div
              key={step.n}
              className="group flex flex-col rounded-2xl border border-border bg-card p-5 shadow-soft transition-all hover:-translate-y-1 hover:shadow-elevated"
            >
              <div className="relative overflow-hidden rounded-xl border border-border bg-muted/40">
                <img
                  src={step.image}
                  alt={step.alt}
                  loading="lazy"
                  width={1024}
                  height={1024}
                  className="block aspect-[4/3] w-full object-cover"
                />
              </div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="text-xs font-semibold tracking-widest text-primary">STEP {step.n}</span>
              </div>
              <h3 className="mt-1 text-lg font-bold">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
